import React, { useEffect, useState } from 'react';
import { Row, Col, Card, CardBody, Modal } from 'reactstrap';
import { get, post, put, del } from 'helpers/api_helper';
import Datatables from 'pages/utils/table/datatable';
import { ManageAllergiesColumns } from './tableColumns';
import { ALLERGIES_URL } from 'helpers/url_helper';
import { showSuccessAlert, showConfirmAlert } from "pages/utils/alertMessages";
import { AvForm, AvField } from 'availity-reactstrap-validation';

const ManageSymstoms = () => {
    const [isForm, setIsForm] = useState(false);
    const [loading, setLoading] = useState(false);
    const [formData, setFormData] = useState({});
    const [rows, setRows] = useState([]);
    const [editMode, setEditMode] = useState(false);
    const [editingId, setEditingId] = useState(null);
    const [pagination, setPagination] = useState({ page: 1, limit: 10, Search: '' });

    const fetchData = async () => {
        const { success, body } = await get(`${ALLERGIES_URL}?page=${pagination.page}&limit=${pagination.limit}&search=${pagination.Search}`);
        if (success) {
            setLoading(true);
            setRows(body);
            setLoading(false);
        }
    }

    useEffect(fetchData, [pagination]);

    const handleToggle = () => {
        setIsForm(!isForm);
        setEditMode(false);
        setEditingId(null);
        setFormData({});
        setLoading(false);
    };

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({
            ...prev,
            [name]: value,
        }));
    };

    const handleSubmit = async () => {
        const url = editMode ? `${ALLERGIES_URL}/${editingId}` : ALLERGIES_URL;
        const method = editMode ? put : post;

        const { success, body } = await method(url, formData);

        if (success) {
            showSuccessAlert(editMode ? 'Symptom updated successfully!' : 'Symptom created successfully!');
            setIsForm(false);
            setFormData({});
            setEditMode(false);
            setEditingId(null);
            fetchData();
        }
    };

    const handleInvalidSubmit = () => {
        alert("Please enter the input field.");
    };

    const handleEdit = (row) => {
        setFormData(row);
        setEditMode(true);
        setEditingId(row.id);
        setIsForm(true);
        setLoading(false);
    };

    const handleDelete = async (id, sts) => {
        const action = sts === 1 ? 'De-activate' : 'Activate';

        const { isConfirmed } = await showConfirmAlert(`${action} this Symptom`, `Do you really want to ${action} this Symptom?`,
            `Yes, ${action} it!`, `${action}d!`, `Symptom has been ${action}d successfully.`);

        if (isConfirmed) {
            const { success } = await del(`${ALLERGIES_URL}/${id}?sts=${sts}`);
            if (success) {
                fetchData();
            }
        }
    };

    return (
        <React.Fragment>
            <Card>
                <CardBody>
                    <Datatables
                        isSearch={true}
                        columns={ManageAllergiesColumns({ "edit": handleEdit, "delete": handleDelete }, pagination)}
                        showTableOnly={true}
                        rowsLength={rows?.totalItems || 0}
                        rows={rows.items || []}
                        keyField={'id'}
                        handleAddButton={handleToggle}
                        title="All Symptom's"
                        isAdd={true}
                        isTableHead={true}
                        loading={loading}
                        ssr={setPagination}
                    />
                </CardBody>
            </Card>

            <Modal isOpen={isForm} toggle={handleToggle} size="xl" centered>
                <AvForm onValidSubmit={handleSubmit} onInvalidSubmit={handleInvalidSubmit} model={formData}>
                    <div className="modal-header">
                        <h5 className="modal-title font-weight-bold">
                            {editMode ? 'Update' : 'Create'} Symptom
                        </h5>
                        <button type="button" className="btn-close" onClick={handleToggle} aria-label="Close" />
                    </div>
                    <div className="modal-body p-4">
                        <Row className="g-3">
                            <Col md={12}>
                                <div className="mb-2">
                                    <AvField
                                        name="title"
                                        label="Symptom / Chief Complaint Title *"
                                        type="text"
                                        placeholder="e.g. Sharp pain in lower right molar on cold foods"
                                        value={formData.title || ''}
                                        onChange={handleChange}
                                        required
                                        errorMessage="Please enter Symptom title"
                                    />
                                </div>
                            </Col>
                        </Row>
                    </div>
                    <div className="modal-footer">
                        <button type="button" className="btn btn-danger" onClick={handleToggle}>
                            Cancel
                        </button>
                        <button type="submit" className="btn btn-primary" disabled={loading}>
                            {loading ? 'Processing...' : (editMode ? 'Update Symptom' : 'Submit Symptom')}
                        </button>
                    </div>
                </AvForm>
            </Modal>
        </React.Fragment>
    );
};

export default ManageSymstoms;
